import React from 'react';
import {
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { boolTrue } from 'Consts/Strings';

export const TaxProductHeader = ({
  productResource,
  metaOverrideSet,
}) => {
  const isFullService = productResource.attr('product') === 'full-service';
  const highlightColor = isFullService ? 'textAttention' : 'textPrimary';
  const documentName = productResource.selectedOptionPrompt('document');

  const setHighlightColorProps = (id) => {
    // If already purchased, color should be disabled
    if (productResource.attr('purchased') === boolTrue) {
      return 'textDisabled';
    }

    // if a discount is present, highlight discounted amount
    if (productResource.attr('firstYearAmountWithDiscount') && productResource.attr('firstYearAmount')) {
      return id === 'firstYearAmountWithDiscount' ? highlightColor : 'textSecondary';
    }

    // otherwise, highlight firstYearAmount
    return id === 'firstYearAmount' ? highlightColor : 'textPrimary';
  };

  return (
    <FDStack direction={'column'} spacing={1.5} justifyContent={'flex-start'} alignItems="flex-start">
      <MetaControl resource={productResource} attrName={'title'} metaOverrideSet={metaOverrideSet} />
      {documentName && <FDTitleText value={documentName} /> }
      <FDStack direction="row" spacing={0.5}>
        <MetaControl resource={productResource} attrName={'firstYearAmountWithDiscount'} metaOverrideSet={metaOverrideSet} color={setHighlightColorProps('firstYearAmountWithDiscount')} />
        <MetaControl resource={productResource} attrName={'firstYearAmount'} metaOverrideSet={metaOverrideSet} color={setHighlightColorProps('firstYearAmount')} />
      </FDStack>
    </FDStack>
  );
};

TaxProductHeader.propTypes = {
  productResource: PropTypes.instanceOf(fr.Resource).isRequired,
  metaOverrideSet: PropTypes.object.isRequired,
};
